import { render } from "./NewsDetailAug2024Page.vue?vue&type=template&id=16ce7ce2"
import script from "./NewsDetailAug2024Page.vue?vue&type=script&lang=js"
export * from "./NewsDetailAug2024Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__